import { Grid } from "@mui/material";
import React from "react";
import "./activity.css";

function ActivityCards() {
  const activityCData = [
    {
      peopleSrc: "./Assets/activity_1.png",
      aHeading: "Creative Art collection",
      idD: "@jimena_stark",
    },
    {
      peopleSrc: "./Assets/activity_2.png",
      aHeading: "Creative Art collection",
      idD: "@jimena_stark",
    },
    {
      peopleSrc: "./Assets/activity_3.png",
      aHeading: "Creative Art collection",
      idD: "@jimena_stark",
    },
    {
      peopleSrc: "./Assets/activity_4.png",
      aHeading: "Creative Art collection",
      idD: "@jimena_stark",
    },
    {
      peopleSrc: "./Assets/activity_5.png",
      aHeading: "Creative Art collection",
      idD: "@jimena_stark",
    },
    {
      peopleSrc: "./Assets/activity_6.png",
      aHeading: "Creative Art collection",
      idD: "@jimena_stark",
    },
  ];
  return (
    <div className="card_a_top">
      <Grid container justifyContent="space-around">
        {activityCData.map((f) => {
          return (
            <Grid item xs={12} lg={6}>
              <div className="a_cards">
                <div className="a_img">
                  <img src={f.peopleSrc} alt="" className="a_img_w" />
                </div>
                <div className="ac_content">
                  <h2 className="a_head">{f.aHeading}</h2>
                  <span>listed by</span>
                  <span className="id_blue">{f.idD}</span>
                  <p className="days_t">last 2 days</p>
                </div>
              </div>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}

export default ActivityCards;
